import UserInfo from "./UserInfo";

export default class Memoria {
  static obterKey(location) {
    var args = location.pathname.toString().split("/");
    if (args.length == 0) {
      throw `Não é possível obter a chave da localização ${location} para usar memória de tela.`;
    }
    return args[1] + "_BOX_KEY";
  }

  static emEdicao(location, estado, versao) {
    if (versao == undefined) {
      throw "Versão do cadastro não informado ao usar Memória, verifique a programação do cadastro";
    }

    const key = this.obterKey(location);
    const obj = {
      path: location.pathname,
      prefeituraId: UserInfo.getPrefeitura(),
      versao: versao,
      cadastroCorrente: estado,
    };
    localStorage.setItem(key, JSON.stringify(obj));
  }

  static removerEdicao(location) {
    const key = this.obterKey(location);
    localStorage.removeItem(key);
  }

  static redirecionarSeNecessario(location, history) {
    if (location == undefined) {
      return false;
    }
    const key = this.obterKey(location);
    const item = localStorage.getItem(key);
    if (item != undefined) {
      const obj = JSON.parse(item);
      if (obj.prefeituraId != UserInfo.getPrefeitura()) {
        localStorage.removeItem(key);
        return;
      }
      history.push(obj.path);
    }
  }

  static resturarEstado(location, cadastroCorrente, versao) {
    if (versao == undefined) {
      throw "Versão do cadastro não informado ao usar Memória, verifique a programação do cadastro";
    }

    if (cadastroCorrente != undefined) {
      return cadastroCorrente;
    }

    const key = this.obterKey(location);
    const item = localStorage.getItem(key);

    if (item != undefined) {
      const obj = JSON.parse(item);

      var prefeituraUsuario = UserInfo.getPrefeitura();
      var prefeituraCadastroCorrente = obj.prefeituraId;

      if (
        prefeituraCadastroCorrente != prefeituraUsuario ||
        obj.versao != versao
      ) {
        localStorage.removeItem(key);
        return cadastroCorrente;
      }
      return obj.cadastroCorrente;
    }

    return cadastroCorrente;
  }
}
